import { getBuffer } from '@dynamic-labs-sdk/client/core';
import bs58 from 'bs58';
import nacl from 'tweetnacl';

export type EncryptPayloadParams = {
  payload: Record<string, unknown>;
  sharedSecret: string;
};

export type EncryptedPayload = {
  data: string;
  nonce: string;
};

/**
 * Encrypts a payload using NaCl box encryption with a shared secret.
 *
 * @param params.payload - The payload object to encrypt
 * @param params.sharedSecret - The base58-encoded shared secret
 * @returns The encrypted data and nonce, both base58-encoded
 */
export const encryptPayload = ({
  payload,
  sharedSecret,
}: EncryptPayloadParams): EncryptedPayload => {
  const nonce = nacl.randomBytes(nacl.box.nonceLength);
  const payloadString = JSON.stringify(payload);
  const payloadBytes = new Uint8Array(getBuffer().from(payloadString, 'utf8'));

  const encrypted = nacl.box.after(
    payloadBytes,
    nonce,
    bs58.decode(sharedSecret)
  );

  return {
    data: bs58.encode(encrypted),
    nonce: bs58.encode(nonce),
  };
};
